// ProV4 kit add-ons (prov4-kit-addons.liquid): Vinyl Graphics extras picked on the number kit page.
// One Add to Cart puts the kit and each picked add-on in the cart as their own lines, tied together by
// hidden properties: the kit line gets "_Kit ID", each add-on line "_Rides With Kit" with the same value.
// The cart page (prov4-kit-addons-cart section) removes add-on lines whose kit is no longer in the cart.
window.Prov4KitLink = window.Prov4KitLink || {
  KIT: '_Kit ID',
  RIDES: '_Rides With Kit',

  newId() {
    return `K${Date.now().toString(36)}${Math.random().toString(36).slice(2, 6)}`.toUpperCase();
  },

  // Returns true when it removed something
  async removeOrphans() {
    const cart = await fetch(`${window.routes.cart_url}.js`).then(response => response.json());
    const kits = new Set(cart.items.map(item => (item.properties || {})[this.KIT]).filter(Boolean));
    const updates = {};
    cart.items.forEach(item => {
      const link = (item.properties || {})[this.RIDES];
      if (link && !kits.has(link)) updates[item.key] = 0;
    });
    if (!Object.keys(updates).length) return false;
    const response = await fetch(`${window.routes.cart_update_url}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates })
    });
    return response.ok;
  }
};

if (!customElements.get('prov4-kit-addons')) {
  customElements.define(
    'prov4-kit-addons',
    class Prov4KitAddons extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.form = document.getElementById(this.dataset.productFormId);
        this.rows = Array.from(this.querySelectorAll('[data-addon]'));

        // The total line sits just above Add to cart, outside this element
        this.total = this.querySelector('[data-addon-total]');
        const buttons = this.form && this.form.querySelector('.product-form__buttons');
        if (this.total && buttons) buttons.before(this.total);
        this.money = new Intl.NumberFormat('en-US', { style: 'currency', currency: this.dataset.currency || 'USD' });
        this.kitQuantity = document.getElementById(`Quantity-${this.sectionId}`);
        if (this.kitQuantity) {
          ['change', 'input'].forEach(type => this.kitQuantity.addEventListener(type, () => this.updateTotal()));
        }
        ['change', 'input'].forEach(type => this.addEventListener(type, (e) => {
          if (e.target.matches('[data-addon-qty]')) this.updateTotal();
        }));

        this.rows.forEach(row => {
          row.querySelector('[data-addon-pick]').addEventListener('change', () => this.updateRow(row));
          row.querySelectorAll('[data-same-choice]').forEach(radio => {
            radio.addEventListener('change', () => this.updateSameName(row));
          });
        });
        this.addEventListener('input', (e) => {
          if (e.target.matches('input[required]') && e.target.checkValidity()) Prov4Fields.setFieldError(e.target, false);
        });

        this.setupVariantChangeListener();
        this.updateKitKinds();

        Prov4Edit.loadItem().then(item => {
          // Editing a kit from the cart: its add-ons are already their own cart lines, edited on their own pages
          if (item) {
            this.hidden = true;
            this.rows.forEach(row => this.setPicked(row, false));
            return;
          }
          // Registered after the kit's required-field check, so a kit with missing fields never gets here
          setTimeout(() => document.addEventListener('submit', (e) => this.onSubmit(e), true), 0);
        });
      }

      setPicked(row, picked) {
        row.querySelector('[data-addon-pick]').checked = picked;
        this.updateRow(row);
      }

      updateRow(row) {
        const on = row.querySelector('[data-addon-pick]').checked && !row.hidden;
        row.querySelector('[data-addon-details]').hidden = !on;
        row.querySelectorAll('[data-addon-details] input').forEach(input => {
          input.disabled = !on;
          if (!on) Prov4Fields.setFieldError(input, false);
        });
        this.updateSameName(row);
        this.updateTotal();
      }

      // Display only: kit price x kit quantity plus each picked add-on. Shown while any add-on is picked
      updateTotal() {
        if (!this.total) return;
        const picked = this.picked();
        this.total.hidden = !picked.length;
        if (!picked.length) return;

        const variant = this.getCurrentVariant();
        const kitQuantity = Math.max(1, parseInt(this.kitQuantity && this.kitQuantity.value, 10) || 1);
        const kitCents = (variant ? Number(variant.price) : 0) * kitQuantity;
        let addonCount = 0;
        let addonCents = 0;
        picked.forEach(row => {
          const quantity = Math.max(1, parseInt(row.querySelector('[data-addon-qty]').value, 10) || 1);
          addonCount += quantity;
          addonCents += Number(row.dataset.price) * quantity;
        });

        const format = cents => this.money.format(cents / 100);
        const kits = kitQuantity > 1 ? `${kitQuantity} kits` : 'Kit';
        const addons = `${addonCount} add-on${addonCount === 1 ? '' : 's'}`;
        this.total.querySelector('[data-addon-total-amount]').textContent = format(kitCents + addonCents);
        this.total.querySelector('[data-addon-total-detail]').textContent =
          `${kits} ${format(kitCents)} + ${addons} ${format(addonCents)}`;
      }

      // Extra driver name: "Same Driver Name" No shows a required Driver Name box
      updateSameName(row) {
        const field = row.querySelector('[data-same-no-field]');
        if (!field) return;
        const choice = row.querySelector('[data-same-choice]:checked').value;
        const differs = choice === 'No';
        row.querySelector('[data-same-selected]').textContent = choice;
        field.hidden = !differs;
        Prov4Fields.setFieldEnabled(field.querySelector('input'), differs && !row.querySelector('[data-addon-details]').hidden, true);
      }

      // Extra car numbers only show when the kit has numbers, extra names only when it has names
      updateKitKinds() {
        const variant = this.getCurrentVariant();
        const title = variant ? (variant.title || '').toLowerCase() : '';
        const has = { numbers: title.includes('numbers'), names: title.includes('names') };
        this.rows.forEach(row => {
          const needs = row.dataset.needs;
          row.hidden = Boolean(needs) && !has[needs];
          this.updateRow(row);
        });
      }

      getCurrentVariant() {
        const script = document.querySelector('variant-selects [data-selected-variant]');
        if (!script) return null;
        try {
          return JSON.parse(script.textContent);
        } catch (e) {
          return null;
        }
      }

      setupVariantChangeListener() {
        if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            if (event.data && event.data.sectionId === this.sectionId) this.updateKitKinds();
          });
        }
        const variantSelects = document.querySelector('variant-selects');
        if (variantSelects) {
          this.variantObserver = new MutationObserver(() => this.updateKitKinds());
          this.variantObserver.observe(variantSelects, { childList: true, subtree: true, characterData: true });
        }
      }

      picked() {
        return this.rows.filter(row => !row.hidden && row.querySelector('[data-addon-pick]').checked);
      }

      async onSubmit(e) {
        if (e.target !== this.form) return;
        const picked = this.picked();
        if (!picked.length) return; // No add-ons: the normal Add to Cart runs

        e.preventDefault();
        e.stopImmediatePropagation();

        const invalid = picked
          .flatMap(row => Array.from(row.querySelectorAll('input[required]')))
          .filter(input => !input.disabled && !input.checkValidity());
        if (invalid.length) {
          invalid.forEach(input => Prov4Fields.setFieldError(input, true));
          invalid[0].focus();
          invalid[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }

        const button = this.form.querySelector('[type="submit"]');
        if (button.getAttribute('aria-disabled') === 'true') return;
        this.setLoading(button, true);
        this.showError('');

        // The kit line, exactly as the normal Add to Cart would send it, plus its link
        const data = new FormData(this.form);
        const kitProps = {};
        for (const [name, value] of data.entries()) {
          const match = name.match(/^properties\[(.*)\]$/);
          if (match) kitProps[match[1]] = value;
        }
        const kitId = Prov4KitLink.newId();
        kitProps[Prov4KitLink.KIT] = kitId;
        const kitItem = { id: Number(data.get('id')), quantity: Number(data.get('quantity')) || 1, properties: kitProps };
        const items = [];

        // Each add-on line. Field names are the locked ones its own product page saves
        const sizing = {};
        if (kitProps['Decal Sizing']) sizing['Decal Sizing'] = kitProps['Decal Sizing'];
        if (kitProps['Custom Sizing Details']) sizing['Custom Sizing Details'] = kitProps['Custom Sizing Details'];
        picked.forEach(row => {
          const props = {};
          const kind = row.dataset.kind;
          if (kind === 'number') {
            Object.assign(props, { 'Match Current Order': 'Yes', 'Same Car Number/Class': 'Yes' }, sizing);
          } else if (kind === 'name') {
            const name = row.querySelector('[data-driver-name]');
            const same = name.disabled ? 'Yes' : 'No';
            Object.assign(props, { 'Match Current Order': 'Yes', 'Same Driver Name': same }, sizing);
            if (same === 'No') props['Driver Name'] = name.value.trim();
          } else if (kind === 'heart') {
            props['Names for Heart Graphic'] = row.querySelector('[data-heart-names]').value.trim();
          }
          props[Prov4KitLink.RIDES] = kitId;
          const quantity = Math.max(1, parseInt(row.querySelector('[data-addon-qty]').value, 10) || 1);
          items.unshift({ id: Number(row.dataset.variantId), quantity, properties: props });
        });

        try {
          const response = await fetch(`${window.routes.cart_add_url}.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            // The cart lists the last line added first, so the kit goes last to sit above its add-ons
            body: JSON.stringify({ items: [...items, kitItem] })
          }).then(r => r.json());
          if (response.status) throw new Error(response.description || response.message);
          window.location = window.routes.cart_url;
        } catch (err) {
          this.showError(err.message || 'Something went wrong. Please try again.');
          this.setLoading(button, false);
        }
      }

      setLoading(button, loading) {
        if (loading) {
          button.setAttribute('aria-disabled', 'true');
        } else {
          button.removeAttribute('aria-disabled');
        }
        button.classList.toggle('loading', loading);
        const spinner = button.querySelector('.loading__spinner');
        if (spinner) spinner.classList.toggle('hidden', !loading);
      }

      showError(message) {
        const box = this.querySelector('[data-addon-error]');
        if (!box) return;
        box.querySelector('[data-addon-error-text]').textContent = message;
        box.hidden = !message;
      }

      disconnectedCallback() {
        if (this.variantChangeUnsubscriber) this.variantChangeUnsubscriber();
        if (this.variantObserver) this.variantObserver.disconnect();
      }
    }
  );
}

// Cart page: drop add-on lines whose kit was removed, on load and after every cart change
document.addEventListener('DOMContentLoaded', () => {
  if (!document.querySelector('[data-prov4-kit-addons-cart]')) return;
  let reloading = false;
  const check = () => {
    if (reloading) return;
    Prov4KitLink.removeOrphans().then(removed => {
      if (removed) {
        reloading = true;
        window.location.reload();
      }
    }).catch(() => {});
  };
  check();
  if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => check());
  }
});
